(function(){
     'use strict';

     angular
        .module('appback')
        .factory('HormonasService', HormonasService);

    HormonasService.$inject = ['$http'];

    function HormonasService($http){


        var service= {
           getHormonas:getHormonas,
        };

        return service;

        function getHormonas(callback)
        {

            var config = {
                headers : {
                    'Content-Type': 'application/x-www-form-urlencoded;charset=utf-8;'
                }
            }

            $http.get('/backend/hormonas/gethormonas', { params : { }  }, config)
            .then(getContentSuccess,getContentFailed);
            function getContentSuccess(data){ 
                callback(data.data);
            }
            function getContentFailed(data){
                
                return false;
            }
            
        }

    }
})();